const CptName = 'ComText'
function formatData (node) {
  // // console.dir(node);
  let value
  if ( node.nodeType == 3) {
    value = node.data
  } else {
    let a_list = node.querySelectorAll("a")
    a_list.forEach(element => {
      element.target = "__blank"
    });
    value = node.innerHTML
  }
  return {
    data: {
      value
    },
    cpt: CptName
  }
}

export default {
  name: 'text',
  formatData
}